import { render, staticRenderFns } from "./AiChatCsatHost.vue?vue&type=template&id=ca788a50"
import script from "./AiChatCsatHost.vue?vue&type=script&lang=js"
export * from "./AiChatCsatHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports